import axios from 'axios'
import { cancelPromise } from './cancel-promise'
import medicareApiAxios from '@cms-max/sls-api-sdk/node_modules/axios/index'
import { buildAbsoluteMedicareMyUrl } from './urls/buildAbsoluteMedicareMyUrl'

/**
 * Default Axios Instance
 */
const axiosInstance = axios.create({
  withCredentials: true,
  // baseURL: `${process.env.REACT_APP_CORE_API_URL!}`,
  adapter: require('axios/lib/adapters/http'),
  headers: { }
})
// Add a request interceptor
axiosInstance.interceptors.request.use(config => {
  // Do something before request is sent
  return config
}, error => {
  // Do something with request error
  return Promise.reject(error)
})
// Add a response interceptor
axiosInstance.interceptors.response.use(response => {
  return response
}, error => {
  if (error.response?.status === 401) {
    window.location.assign('https://medicare.gov/mbp/signout.aspx')
    return cancelPromise()
  } else {
    return Promise.reject(error)
  }
})

const errorResponseHandler = (error: any) => {
  if (error.response?.status === 500) {
    // oauthRedirectUrl
    // TODO - make MCF excluded from the redirect to error cause it is not an authenticatedRoute
    // if(!window.location.pathname.includes('error') && seoArrayObject.find(x => x.route === window.location.pathname)?.oauthRedirectUrl) {}
    // the actual object lookup won't be a `===` check, it will be an `includes` string check
    if (!window.location.pathname.includes('error')) {
      window.location.assign(buildAbsoluteMedicareMyUrl('/error'))
    }
    return cancelPromise()
  } else if (error.response?.status === 401) {
    window.location.assign('https://medicare.gov/mbp/signout.aspx')
    return cancelPromise()
  } else {
    return Promise.reject(error)
  }
}

/**
 * Axios Instance for Beneficiary endpoint only on 500 server failure
 */
const axiosInstanceForBeneficiary = axios.create({
  withCredentials: true,
  // baseURL: `${process.env.REACT_APP_CORE_API_URL!}`,
  adapter: require('axios/lib/adapters/http'),
  headers: { }
})

// Add a response interceptor
axiosInstanceForBeneficiary.interceptors.response.use(response => response, errorResponseHandler)

/**
 * Axioss Instance for Beneficiary endpoint --- used with the medicare-api-sdk
 */
const medicareSdkAxiosInstanceForBeneficiary = medicareApiAxios.create({
  withCredentials: true
})
medicareSdkAxiosInstanceForBeneficiary.interceptors.response.use(response => response, errorResponseHandler)

export { axiosInstance, axiosInstanceForBeneficiary, medicareSdkAxiosInstanceForBeneficiary }
